module.exports = __webpack_public_path__ + "img/SIKH TURBAN LIME.61d0f8e.svg";